import { memo } from "react";

import { Icon } from "@react/components/Icon";
import { Text } from "@react/components/Text";
import { focusRing } from "@react/utilities";
import { tw } from "classnames";

type Props = {
  handleOpenGiftNoteDrawer: () => void;
  hasPreviouslySavedGiftNote: boolean;
  text: {
    giftButtonText?: string;
    giftEditNote?: string;
    giftText?: string;
  };
};

const styles = {
  giftNote: tw(
    "flex",
    "justify-between",
    "bg-background-primary",
    "px-6",
    "py-4",
    "border-0",
    "border-t",
    "border-b",
    "border-solid",
    "border-divider",
    "text-primary"
  ),
  giftNoteAddButton: tw(
    "flex",
    "items-center",
    "border-0",
    "bg-transparent",
    "cursor-pointer",
    focusRing
  ),
  giftNoteEditButton: tw(
    "flex",
    "items-center",
    "border-0",
    "bg-transparent",
    "cursor-pointer",
    "underline",
    focusRing
  ),
  giftNoteIcon: tw("mr-1", "h-4", "w-4"),
  giftNoteText: tw("grow"),
};

const CartGiftNoteStatusViewBase = ({
  handleOpenGiftNoteDrawer,
  hasPreviouslySavedGiftNote,
  text,
}: Props) => {
  return (
    <div className={styles.giftNote}>
      {hasPreviouslySavedGiftNote ? (
        <>
          <Icon className={styles.giftNoteIcon} name="checkmark" />
          <Text as="body2" className={styles.giftNoteText}>
            {text.giftText}
          </Text>
          <button
            className={styles.giftNoteEditButton}
            onClick={handleOpenGiftNoteDrawer}
          >
            <Text as="body2">{text.giftEditNote}</Text>
          </button>
        </>
      ) : (
        <>
          <button
            className={styles.giftNoteAddButton}
            onClick={handleOpenGiftNoteDrawer}
          >
            <Icon className={styles.giftNoteIcon} name="plus" />
            <Text as="body2">{text.giftButtonText}</Text>
          </button>
        </>
      )}
    </div>
  );
};

export const CartGiftNoteStatusView = memo(CartGiftNoteStatusViewBase);
